module.exports = __webpack_public_path__ + "img/ball_8.b23450ec.png";